import journal from '@/api/journal'
import subscribe from '@/api/subscribe'
import { mapGetters, mapActions } from 'vuex'
import help from '@/utils/help'
import publisher from '@/api/publisher'

const columns = [
  {
    title: '',
    enTitle: 'Sources',
    width: 150,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Email',
    width: 150,
    dataIndex: 'email',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Subscribe Date',
    width: 150,
    dataIndex: 'createTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  data() {
    return {
      journalList: [],
      params: { sorted: 'createTime' },
      nameList: [],
      date: [],
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      dataSource: [],
      columns: columns
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      publisherInfo: 'getPublisherInfo'
    })
  },
  mounted() {
    this.getJournalList()
    this.getList()
    help.closeAutocomplete()
  },
  methods: {
    ...mapActions(['updatePublisherId', 'updatePublisherInfo']),
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      let publisherId = 'imr'
      await this.getPublisherInfo(publisherId)
      localStorage.setItem('publisherInfo', JSON.stringify(this.publisherInfo))
      let publisherInfo =
        this.publisherInfo || JSON.parse(localStorage.getItem('publisherInfo'))
      this.journalList.unshift(publisherInfo)
    },
    async getPublisherInfo(publisherId) {
      this.updatePublisherInfo(await publisher.query(publisherId))
      this.updatePublisherId(this.publisherInfo.id)
    },
    handleDateChange(date) {
      this.params.startTime = date[0] ? date[0].startOf('d') : ''
      this.params.endTime = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await subscribe.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleClear() {
      this.params = {}
      this.nameList = []
      this.date = []
      this.getList()
    },
    async exp() {
      let { nameList, startTime, endTime, sorted } = this.params
      let data = {
        nameList,
        startTime,
        endTime,
        sorted
      }
      const res = await subscribe.export(data)
      help.download(res.url, res.fileName)
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    changeSource(val) {
      this.params.nameList = val.join()
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this Subscriber?',
        content:
          'Please be aware of once this Subscriber is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await subscribe.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Subscriber has been deleted!'
        })
        this.getList()
      })
    }
  }
}
